// ContactForm.jsx
import { useState, useRef } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Container,
  Alert,
  CircularProgress,
  Paper,
  Autocomplete
} from '@mui/material';
import emailjs from '@emailjs/browser';
import services from '../../../../../data/services.json';
import emailjscreds from '../../../../../data/emailjscreds.json';

export default function ContactForm(){
  const formRef = useRef();
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: '', message: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', message: '' });

    try {
      await emailjs.sendForm(
        emailjscreds.service,
        emailjscreds.template,
        formRef.current,
        emailjscreds.publickey      
    );
      setStatus({ type: 'success', message: 'Message sent successfully!' });
      e.target.reset();
    } catch (error) {
      setStatus({ type: 'error', message: 'Failed to send message. Please try again.' });
      console.log('Error:',error.message)
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
    <Paper>
      <Box
        component="form"
        ref={formRef}
        onSubmit={handleSubmit}
        sx={{ p: 2 }}
      >
        <Typography variant="h5" gutterBottom>
          Φόρμα Επικοινωνίας
        </Typography>

        {status.message && (
          <Alert severity={status.type} sx={{ mb: 2 }}>
            {status.message}
          </Alert>
        )}

        <TextField
          required
          fullWidth
          label="Ονοματεπώνυμο"
          name="user_name"
          margin="normal"
          variant="outlined"
        />

        <TextField
          required
          fullWidth
          label="Email"
          name="user_email"
          type="email"
          margin="normal"
          variant="outlined"
        />

        <TextField
          required
          fullWidth
          label="Τηλέφωνο"
          name="user_tel"
          type="tel"
          margin="normal"
          variant="outlined"
        />

        <Autocomplete
            fullWidth
            freeSolo
            options={services.services.map((service)=>service.title)}
            renderInput={(params) => 
                <TextField {...params} 
                    required
                    fullWidth
                    label="Θεραπεία"
                    name="therapy"
                    margin="normal"
                    variant="outlined" 
                />}
        />

        <TextField
          required
          fullWidth
          label="Μήνυμα"
          name="message"
          multiline
          rows={5}
          margin="normal"
          variant="outlined"
        />

        <Button
          type="submit"
          variant="contained"
          size="large"
          disabled={loading}
          fullWidth
          sx={{ mt: 2, textTransform:'none' }}
        >
          {loading ? <CircularProgress size={24} /> : 'Αποστολή Αιτήματος'}
        </Button>
      </Box>
      </Paper>
    </Container>
  );
};
